import OverlappingPlannedBreaks from "components/pages/schedule/helpers/OverlappingPlannedBreaks";
import Schedule from "domain/Schedule";
import WorkBlock from "domain/WorkBlock";
import DateTime from "utils/DateTime";

export default function fillInGapTimespan({ block, gapFiller, line, pressedKey }) {
  const fullShiftTimespan = gapFiller.timespanWithinGap(pressedKey);

  if (!fullShiftTimespan) {
    return null;
  }

  const getOverlappingPlannedBreaks = (workBlock, requiredDuration) => {
    const overlappingPlannedBreaks = new OverlappingPlannedBreaks({
      line,
    });

    return overlappingPlannedBreaks.getOverlappingPlannedBreaks(workBlock, requiredDuration * 1000);
  };

  const gapBlock = {
    ...block,
    line: { ...line },
    lineEfficiency: line.efficiency,
    quantity: block.workOrder.unscheduledQuantity + block.quantity,
    startsAt: DateTime.toISO8601(fullShiftTimespan.startTime),
    workOrder: { ...block.workOrder, unscheduledQuantity: block.workOrder.unscheduledQuantity + block.quantity },
  };

  const requiredDuration = WorkBlock.calculateBlockDurationForLine(gapBlock, line);
  const overlappingPlannedBreaks = getOverlappingPlannedBreaks(gapBlock, requiredDuration);
  const overlappingPlannedBreakDuration = overlappingPlannedBreaks.reduce(
    (acc, breakDuration) => acc + breakDuration.duration,
    0,
  );

  return Schedule.shrinkTimeSpanToWorkOrderRemaining({
    existingBlock: block,
    remainingBlockDuration: requiredDuration + overlappingPlannedBreakDuration,
    timespan: fullShiftTimespan,
  });
}
